import { defineWebModule } from '@itc/sdk';
import { defineAsyncComponent } from 'vue';

// Timers in the shell (design §7.5): its pages, nav, admin section, reminder
// renderer. Stratus v2 has one accent app-wide (ADR 0010), so no accent of its own.
export default defineWebModule({
  name: 'timers',
  title: 'Timers',
  routes: [
    { path: '/timers', component: () => import('./pages/TimersBoard.vue'), meta: { permission: 'timers.view', title: 'Timers' } },
    { path: '/timers/mine', component: () => import('./pages/MyTimers.vue'), meta: { permission: 'timers.personal', title: 'My timers' } },
    { path: '/timers/new', component: () => import('./pages/TimerForm.vue'), meta: { permission: 'timers.manage', title: 'New timer' } },
    { path: '/timers/mine/new', component: () => import('./pages/TimerForm.vue'), meta: { permission: 'timers.personal', title: 'New personal timer' } },
    // A timer's own pages: an org timer needs timers.view, a personal one its owner; the page and the server check.
    { path: '/timers/:id', component: () => import('./pages/TimerDetail.vue'), meta: { permission: 'authenticated', title: 'Timer' } },
    { path: '/timers/:id/edit', component: () => import('./pages/TimerForm.vue'), meta: { permission: 'authenticated', title: 'Edit timer' } },
  ],
  widgets: [{ id: 'timers.next', title: 'Next up', permission: 'timers.view', component: () => import('./widgets/NextUpWidget.vue') }],
  nav: [
    { label: 'Timers', to: '/timers', permission: 'timers.view', icon: 'timers' },
    { label: 'My timers', to: '/timers/mine', permission: 'timers.personal', icon: 'user' },
  ],
  admin: [
    { label: 'Timers', path: '/admin/timers', component: () => import('./admin/AdminPage.vue'), permission: 'timers.admin' },
    { label: 'Executive Hangar import', path: '/admin/timers/hangar', component: () => import('./admin/HangarImport.vue'), permission: 'timers.admin' },
  ],
  // Loaded when first shown, like the pages.
  notificationRenderers: { 'timers.reminder': defineAsyncComponent(() => import('./components/ReminderItem.vue')) },
});
